import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GeneralConstants } from 'app/constants/general-constants';
import { FScoreMetric } from 'app/model/redshift/f-score-metric';
import { dialogService } from 'app/services/dialog.service';
import { fScoreReportService } from 'app/services/seam-request/f-score-report.service';
import { FScoreReportGrid } from 'features/qa/f-score/f-score-report-grid';

interface FScoreDialogProps {
    storeId?: number;
    onClose?: () => void;
}

export const FScoreStoreDialog: React.FunctionComponent<FScoreDialogProps> = ({ storeId, onClose }) => {
    const [data, setData] = useState<FScoreMetric[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!storeId) {
            // do not load fScores if we don't have store id.
            return undefined;
        }

        setLoading(true);
        const sub = fScoreReportService
            .list({
                queryFilters: {
                    storeId,
                },
                pageSize: GeneralConstants.PAGE_SIZE_LARGE,
            })
            .subscribe((page) => {
                setLoading(false);
                setData(page.data);
            });

        return () => sub.unsubscribe();
    }, [storeId]);

    return (
        <Dialog
            open={storeId !== undefined}
            fullWidth
            maxWidth='lg'
            onClose={() => dialogService.dismiss()}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
        >
            <DialogTitle id='alert-dialog-title'>{'Confirmation'}</DialogTitle>
            <DialogContent>
                <FScoreReportGrid
                    rows={data}
                    loading={loading}
                    density='compact'
                    pagination
                    autoHeight
                    pageSizeOptions={GeneralConstants.PAGE_SIZE_OPTIONS}
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                            },
                        },
                        pagination: {
                            paginationModel: {
                                pageSize: GeneralConstants.PAGE_SIZE_SMALL,
                            },
                        },
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color='primary'>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};
